import { render } from "./SignManage.vue?vue&type=template&id=ab985646&scoped=true"
import script from "./SignManage.vue?vue&type=script&lang=js"
export * from "./SignManage.vue?vue&type=script&lang=js"

import "./SignManage.vue?vue&type=style&index=0&id=ab985646&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-ab985646"

export default script